import { queryOptions } from '@tanstack/react-query';
import { CollectorService } from '@/features/collectors/services/CollectorService.ts';

export const collectorQueryKeys = {
  all: ['collectors'],
  list: () => [...collectorQueryKeys.all, 'list'],
};

export const collectorQueries = {
  list: () =>
    queryOptions({
      queryKey: collectorQueryKeys.list(),
      queryFn: CollectorService.list,
    }),
};
